import { FEATURES } from '../../company/features';

/**
 * Backend capabilities of Mimesa's API (mimesa/service, class routes in `apis/*.js`).
 * Every flag not listed is OFF: Mimesa's API has no auditors (`/audit/*`), no per-piso price
 * lists or price resolution, no store-type overrides, no store-check recency, no per-store
 * contract/campaign prices, no poll delete and none of Mary's reports.
 *
 * The bundled catalog is Mary's product list: never shown to Mimesa.
 */
const MIMESA_FEATURES = Object.freeze({
    [FEATURES.AUDITOR]: false,
    [FEATURES.STORE_PRICE_LISTS]: false,
    [FEATURES.STORE_PRICE_RESOLVE]: false,
    [FEATURES.STORE_OVERRIDES]: false,
    [FEATURES.STORE_CHECK_RECENCY]: false,
    [FEATURES.TRADE_STORE_PRICES]: false,
    [FEATURES.POLL_DELETE]: false,
    [FEATURES.INTERACTIONS]: false,
    [FEATURES.ROUTE_EFFICIENCY]: false,
    [FEATURES.COMPETITOR_BRANDS]: false,
    [FEATURES.SEGMENTATION_TYPES]: false,
    [FEATURES.DISTRIBUTOR_PRICES]: false,
    [FEATURES.LEVANTAMIENTO]: false,
    [FEATURES.SHELF_REPORTS]: false,
    [FEATURES.SOS_ANALYSIS]: false,
    [FEATURES.BUNDLED_CATALOG]: false,
    // Encuestas: off unless central-service turns it on (`companies.mimesa.features.polls`).
    [FEATURES.POLLS]: false,
});

export default MIMESA_FEATURES;
